<template>
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
      <iframe v-if="parameter.use=='youtube'"
        id="ytplayer" type="text/html" width="100%" height="320px"
        :src="parameter.url"
        frameborder="0" allowfullscreen></iframe>
      <video class="-video" v-if="parameter.use!='youtube'"
      :src="movieCreate(message)" controls>
      <p>動画を再生するにはサポートされたブラウザが必要です。</p>
      </video>
  </div>
</template>

<script>
// 外部関数
import {
  movieCreate
} from "@/functions/balloonFunc"

export default {
  name: "MovieParts",
  props: ['message', 'speaker', 'color', 'parameter'],
  mounted () {
  },
  methods: {
    movieCreate (m) {
      return movieCreate(m)
    }
  },
  computed: {
  },
  data () {
    return {
    }
  }
};
</script>

<style scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-wrap;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
.other-box::before {
    content: "";
    display: block;
    padding-top: 56.25%;
}
.-video {
  height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/MovieParts.vue